import React from 'react'
import PropTypes from 'prop-types'
import {SimpleGrid} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Component} from '@salesforce/commerce-sdk-react/components'

/**
 * PDCShippingPDPDetailsLayout component.
 *
 * This component is responsible for rendering the shipping details layout
 * on the Product Detail Page (PDP) based on the provided regions.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.regions - An array of region objects that determine
 * the layout and components to be rendered.
 *
 * @returns {JSX.Element} The rendered shipping details layout.
 */
export const PDCShippingPDPDetailsLayout = ({regions}) => {
    let components = []
    if (regions) {
        components = regions[0].components || []
    }
    return (
        <SimpleGrid>
            {components.map((component, index) => (
                <Component key={index} component={component} />
            ))}
        </SimpleGrid>
    )
}
export default PDCShippingPDPDetailsLayout
PDCShippingPDPDetailsLayout.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.object,
                    id: PropTypes.string,
                    typeId: PropTypes.string
                })
            )
        })
    )
}
